import { Ref, ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'

import {
  intShipConfigList,
  getEstimateIntShip,
  getAdditionalLabel,
  getListByType
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'
import { getWarehouseCode } from '@/store'
export default (wareType:string) => {
  const store = useStore()
  const form: any = reactive({
    customerShopName: store.getters.shopname,
    additionalList: [],
    declarationAddress: [],
    distribution: null,
    forwarder: null,
    intForwarderConfigId: null,
    intShipConfigId: null,
    labelTemplateId: '',
    replenishPlanItemList: [],
    title: '',
    shippingType: null
  })
  const rules = {
    title: [{ required: true, message: t('必填'), trigger: 'blur' }],
    intShipConfigId: [{ required: true, message: t('物流方式不能为空'), trigger: 'blur' }],
    labelTemplateId: [{ required: true, message: t('必填'), trigger: 'change' }],
    replenishPlanItemList: {
      deliveryNums: [{
        validator: (rule: any, val: any, callback: any) => {
          if (Number(val) > 0) {
            callback()
          } else {
            callback(t('必填'))
          }
        },
        trigger: 'blur'
      }]
    }
  }

  const formRef = ref()

  const weight = ref()
  const estimateIntShip = ref(0)
  const getEstimateIntShipInfo = () => {
    if (!form.intShipConfigId) {
      ElMessage.warning(t('国际物流配置id不能为空'))
      return
    }
    getEstimateIntShip({
      intShipConfigId: form.intShipConfigId,
      weight: weight.value
    }).then(res => {
      estimateIntShip.value = res.data?.estimateIntShipFee
    })
  }

  const changePrice: any = (row: any) => {
    const num = row.deliveryNums.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    row.deliveryNums = num ? Math.min(num, (row.useable || 0)) : ''
  }
  const inputPrice: any = (row: any) => {
    const num = row.deliveryNums.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    row.deliveryNums = num
  }

  const additionalLabelDict: any = ref({})
  getAdditionalLabel().then((res) => {
    (res.data || []).forEach((e: { dictKey: string | number; dictValue: any; }) => {
      console.log(e.dictKey, e.dictValue)
      additionalLabelDict.value[e.dictKey] = e.dictValue?.split(',')?.[0]
    })
  })

  const intShipTypeOption: any = ref([])
  intShipConfigList({ systemSource: store.getters.plat === 'd2c' ? 1 : 2, warehouseCode: getWarehouseCode(wareType === 'KR') }).then(res => {
    intShipTypeOption.value = res.data
  })
  const templateOption:Ref<any> = ref([])
  const templatePreview: any = ref('')
  getListByType().then((res: any) => {
    if (res.success) {
      templateOption.value = res.data
    }
  })
  const intShipType = computed({
    get: () => form.intShipConfigId,
    set: (v) => {
      const t = intShipTypeOption.value.find((e: { intShipConfigId: string }) => e.intShipConfigId === v)
      form.intShipConfigId = v
      form.intForwarderConfigId = t.forwarder?.intForwarderConfigId
      form.distribution = t.distribution
      form.forwarder = t.forwarder?.forwarder
      form.shippingType = t.forwarder?.shippingType
    }
  })

  return {
    form,
    rules,
    formRef,
    weight,
    estimateIntShip,
    getEstimateIntShipInfo,
    changePrice,
    inputPrice,
    additionalLabelDict,
    intShipTypeOption,
    intShipType,
    templateOption,
    templatePreview
  }
}
